var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 24.001,
    viewBox: "0 0 24.001 24.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17215",
    "data-name": "Group 17215",
    transform: "translate(-45 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4634426_interface_off_shutdown_turn_off_icon",
    "data-name": "4634426_interface_off_shutdown_turn off_icon",
    transform: "translate(45 1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16175",
    "data-name": "Group 16175",
    transform: "translate(10.641 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M16.359,15.876A1.359,1.359,0,0,1,15,14.516V6.359a1.359,1.359,0,0,1,2.719,0v8.157A1.359,1.359,0,0,1,16.359,15.876Z",
    transform: "translate(-15 -5)",
    fill: "#ff5151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16176",
    "data-name": "Group 16176",
    transform: "translate(0 2.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    d: "M17,27.749c-6.617,0-12-5.109-12-11.389A11.4,11.4,0,0,1,12.115,5.954a1.113,1.113,0,0,1,1.44.523A1.014,1.014,0,0,1,13,7.845,9.328,9.328,0,0,0,7.182,16.36,9.589,9.589,0,0,0,17,25.678a9.589,9.589,0,0,0,9.819-9.319,9.321,9.321,0,0,0-5.892-8.544,1.016,1.016,0,0,1-.563-1.364A1.116,1.116,0,0,1,21.8,5.918,11.391,11.391,0,0,1,29,16.36C29,22.64,23.618,27.749,17,27.749Z",
    transform: "translate(-5 -5.832)",
    fill: "#ff5151"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5afed084413215ee8861efea41738770.svg";
export { ForwardRef as ReactComponent };